import React from 'react';
import LimiteComissaoService from '../../../../lib/api/limiteComissao/limiteComissao';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ParametroLimiteComissao extends React.Component<{}, {}> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    baixarParametrosExcel() {
        return LimiteComissaoService.baixarParametrosExcel();
    }

    reenviarParametrosExcel() {
        return LimiteComissaoService.reenviarParametrosExcel();
    }

    render() {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.reenviarParametrosExcel}
                baixarExcelParametros={this.baixarParametrosExcel}
                enviarExcelParametros={LimiteComissaoService.salvarParametrosExcel}
                deletarExcelParametros={LimiteComissaoService.deletarParametrosExcel}
                nomeDoArquivo='Parametro Limite Comissão'
            />
        );
    }
}

export default ParametroLimiteComissao;
